var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/ui/components/navbar.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import classNames from 'clsx';
import React, { useRef, useState } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { logIn, verifyCredentials } from 'soapbox/actions/auth';
import { fetchInstance } from 'soapbox/actions/instance';
import { openSidebar } from 'soapbox/actions/sidebar';
import SiteLogo from 'soapbox/components/site-logo';
import { Avatar, Button, Form, IconButton, Input, Tooltip } from 'soapbox/components/ui';
import Search from 'soapbox/features/compose/components/search';
import { useOwnAccount, useSoapboxConfig } from 'soapbox/hooks';
import ProfileDropdown from './profile-dropdown';
const messages = defineMessages({
  login: {
    "id": "navbar.login.action",
    "defaultMessage": "Log in"
  },
  username: {
    "id": "navbar.login.username.placeholder",
    "defaultMessage": "Email or username"
  },
  password: {
    "id": "navbar.login.password.label",
    "defaultMessage": "Password"
  },
  forgotPassword: {
    "id": "navbar.login.forgot_password",
    "defaultMessage": "Forgot password?"
  }
});

const Navbar = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const node = useRef(null);
  const account = useOwnAccount();
  const soapboxConfig = useSoapboxConfig();
  const singleUserMode = soapboxConfig.get('singleUserMode');
  const [isLoading, setLoading] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [mfaToken, setMfaToken] = useState(false);

  const onOpenSidebar = () => dispatch(openSidebar());

  const handleSubmit = event => {
    event.preventDefault();
    setLoading(true);
    dispatch(logIn(username, password)).then(_ref => {
      let {
        access_token
      } = _ref;
      setLoading(false);
      return dispatch(verifyCredentials(access_token)) // Refetch the instance for authenticated fetch
      .then(() => dispatch(fetchInstance()));
    }).catch(error => {
      var _error$response;

      setLoading(false);
      const data = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data;

      if ((data === null || data === void 0 ? void 0 : data.error) === 'mfa_required') {
        setMfaToken(data.mfa_token);
      }
    });
  };

  if (mfaToken) return /*#__PURE__*/React.createElement(Redirect, {
    to: "/login?token=".concat(encodeURIComponent(mfaToken)),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 24
    }
  });
  return /*#__PURE__*/React.createElement("nav", {
    className: "bg-white dark:bg-primary-900 shadow z-50 sticky top-0",
    ref: node,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-w-7xl mx-auto px-2 sm:px-6 lg:px-8",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative flex justify-between h-12 lg:h-16",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 9
    }
  }, account && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 left-0 flex items-center lg:hidden",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onOpenSidebar,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Avatar, {
    src: account.avatar,
    size: 34,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames({
      'flex-1 flex items-center lg:items-stretch space-x-4': true,
      'justify-center lg:justify-start': account,
      'justify-start': !account
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Link, {
    key: "logo",
    to: "/",
    "data-preview-title-id": "column.home",
    className: "flex-shrink-0 flex items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(SiteLogo, {
    alt: "Logo",
    className: "h-5 w-auto cursor-pointer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 15
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "hidden",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "tabs_bar.home",
    defaultMessage: "Home",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 40
    }
  }))), account && /*#__PURE__*/React.createElement("div", {
    className: "flex-1 hidden lg:flex justify-center px-2 lg:ml-6 lg:justify-start items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-w-xl w-full lg:max-w-xs hidden lg:block",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Search, {
    openInRoute: true,
    autosuggest: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 19
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 right-0 flex items-center pr-2 lg:static lg:inset-auto lg:ml-6 lg:pr-0 space-x-3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 11
    }
  }, account ? /*#__PURE__*/React.createElement("div", {
    className: "hidden relative lg:flex items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(ProfileDropdown, {
    account: account,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Avatar, {
    src: account.avatar,
    size: 34,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 19
    }
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form, {
    className: "hidden lg:flex space-x-2 items-center",
    onSubmit: handleSubmit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Input, {
    required: true,
    value: username,
    onChange: event => setUsername(event.target.value),
    type: "text",
    placeholder: intl.formatMessage(messages.username),
    className: "max-w-[200px]",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(Input, {
    required: true,
    value: password,
    onChange: event => setPassword(event.target.value),
    type: "password",
    placeholder: intl.formatMessage(messages.password),
    className: "max-w-[200px]",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(Link, {
    to: "/reset-password",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 130,
      columnNumber: 19
    }
  }, /*#__PURE__*/React.createElement(Tooltip, {
    text: intl.formatMessage(messages.forgotPassword),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 131,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    src: require('@tabler/icons/help.svg'),
    className: "bg-transparent text-gray-400 dark:text-gray-500 hover:text-gray-700 dark:hover:text-gray-200 cursor-pointer",
    iconClassName: "w-5 h-5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 132,
      columnNumber: 23
    }
  }))), /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    type: "submit",
    disabled: isLoading,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 140,
      columnNumber: 19
    }
  }, intl.formatMessage(messages.login))), /*#__PURE__*/React.createElement("div", {
    className: "space-x-1.5 lg:hidden",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 149,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "tertiary",
    to: "/login",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 150,
      columnNumber: 19
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "account.login",
    defaultMessage: "Log In",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 151,
      columnNumber: 21
    }
  })), !singleUserMode && /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    to: "/signup",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 155,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "account.register",
    defaultMessage: "Sign up",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 156,
      columnNumber: 23
    }
  }))))))));
};

export default Navbar;